import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import InvoiceHeader from '../layout/invoice/InvoiceHeader'
import InvoiceAddress from '../layout/invoice/InvoiceAddress'
import { useParams, Link, useNavigate } from 'react-router-dom';
import InvoiceTable from '../layout/invoice/InvoiceTable'
import { PURCHASE_ORDER_DETAILS, COMPANY_DETAILS, ORDER_ACTIONS, CONVERT_TO_BILL } from '../../../data/url'
import httpClient from '../../../http/HttpRequest'
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import Alert from '../../../feature/Alert'
import { generatePDF } from '../../pdf/GeneratePDF'

export default function ViewOrder() {

     const [order, setOrder] = useState({});
     const [details, setOrderDetails] = useState([]);
     const [company, setCompanyDetails] = useState({});
     const [customer, setCustomer] = useState({});

     const navigate = useNavigate();
     const { id } = useParams();
     const { t } = useTranslation();

     const componentRef = React.useRef();

     const handlePrint = useReactToPrint({
          content: () => componentRef.current,
     });


     useEffect(() => {
          getOrderDetails();
          getCompanyDetails();
     }, []);


     const getOrderDetails = async (e) => {
          const res = await httpClient.post(PURCHASE_ORDER_DETAILS, { order_id: id });
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    setOrder(result.data.order);
                    setOrderDetails(result.data.details);
                    setCustomer(result.data.customer);
               }
          }
     }

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setCompanyDetails(result.data);
               }
          };
     }

     const makePdf = () => {
          let filename = `${order.po_number}-PO`;
          generatePDF(filename);
     };

     const approveOrder = async (action) => {
          let post = { action: action, order_id: order.order_id };
          const res = await httpClient.post(ORDER_ACTIONS, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);
                    getOrderDetails();
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     const convertToBill = async () => {
          let post = { order_id: order.order_id };
          const res = await httpClient.post(CONVERT_TO_BILL, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);                  
               } else {
                    Alert.info(result.message);
               }
               navigate('/root/bill/view/' + result.bill_id);
          }
     }

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="view_purchase_order" subTitle="purchase_orders" subTitleLink="root/po" />
                    <div className="card col-md-11 m-auto section-to-print" id="invoice">
                         <div className="card-body" id="print_section">
                              <InvoiceHeader title="purchase_order" number={`${order.prefix} - ${order.po_number}`} />
                              <InvoiceAddress title="vendor" customer={customer} company={company} order={order} />
                              <InvoiceTable title="vendor" products={details} order={order} company={company} customer={customer} />
                         </div>
                         <div className='text-center'>
                              <Link to={`/root/po/edit/${id}`} type="button" className="btn btn-sm btn-primary  m-1">
                                   {t('edit')}
                              </Link>
                              <button className="btn btn-sm btn-danger m-1" onClick={makePdf}>{t('pdf')}</button>
                              <button className="btn btn-sm btn-info m-1" onClick={handlePrint}>{t('print')}</button>
                              {order.status === "1" && <button className="btn btn-sm btn-primary m-1" onClick={() => approveOrder(2)}>{t('approve')}</button>}
                              {order.status === "1" && <button className="btn btn-sm btn-danger m-1" onClick={() => approveOrder(3)}>{t('reject')}</button>}
                              {order.status === "2" && <button className="btn btn-sm btn-success m-1" onClick={convertToBill}>{t('convert_to_bill')}</button>}
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
